export const filterRender = (data, numberRender) => {
    let render = data[numberRender].thumbnail
    return render
}